<h2>Medical Alert <button class="icon--add btn--default" type="button" (click)="addAlert()" *ngIf="canEdit">Add Alert</button><button class="icon--history btn--default" (click)="showHistory(customerNumber)">View History</button></h2>
<p-table #dt [value]="alerts" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th>Alert Type</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="3 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{ data.alertType }}</td>
            <td>{{ data.effectiveDate | shortDate }}</td>
            <td>{{ data.endDate | shortDate }}</td>
            <td class="text-center" *ngIf="canEdit">  <a class="icon--edit" title="Edit Alert" href="javascript:void(0);" (click)="editAlert(data.id)"></a></td>
        </tr>
    </ng-template>
</p-table>
